<template>
                <footer class="lmd-footer">
                <div class="container-fluid">
                    <div class="custom-row">
                        <div class="footer-links">
                            <ul>
                                <li><router-link :to="`/privacy-policy`" @click="handleClick()">Privacy Policy</router-link></li>
                                <li><router-link :to="`/terms-condition`" @click="handleClick()">Terms & Conditions</router-link></li>
                            </ul>
                        </div>
                        <div class="social-links">
                            <ul>
                                <li><a href="#"><img src="@/assets/images/facebook-f.svg" alt="Facebook" /></a></li>
                                <li><a href="#"><img src="@/assets/images/twitter.svg" alt="Facebook" /></a></li>
                                <li><a href="#"><img src="@/assets/images/linkedin-in.svg" alt="Facebook" /></a></li>
                                
                            </ul>
                        </div>
                        <div class="copyright-text">
                            2025 LMD Consulting, LLC , All Rights Reserved
                        </div>
                    </div>
                    
                </div>
            </footer>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import customJSFunction from "@/assets/js/custom.js";
import $ from 'jquery';


export default {
name: "HomePage",
mounted() {
customJSFunction();
},
methods: {

    handleClick() {
      this.onTop();
      this.closeMenu();
    },
    onTop(){
      window.scrollTo(0, 0);
    //   setTimeout(() => {
    //   window.location.href = window.location.href;
    //   }, 10); // small delay to allow scroll before reload
    } ,
    closeMenu() {
            setTimeout(() => {
                $('#menuOpen').removeClass('show-menu');
                $('#menuclick').removeClass('close-menu');
            }, 100); // 100ms delay
            }  
}
};
</script>